import api from './HttpService';
import { DEPARTMENT } from '../configs/ApiActionUrl';

async function getAll(pageOption, sortData, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search_key=${encodeURIComponent(keyword)}`;
  }
  try {
    const res = await api.get(DEPARTMENT.LIST + query);
    return res;
  } catch (error) {
    // Handle errors here
    return error; // Rethrow the error to propagate it further
  }
}

async function add(postData) {
  const res = await api.post(DEPARTMENT.ADD, postData);
  return res;
}

async function getItem(code) {
  const res = await api.get(`${DEPARTMENT.EDIT}/${code}`);
  return res;
}

async function update(code, postData) {
  const res = await api.patch(`${DEPARTMENT.UPDATE}/${code}`, postData);
  return res;
}

async function deleteItem(code) {
  const res = await api.delete(`${DEPARTMENT.DELETE}/${code}`);
  return res;
}

async function getActiveItem() {
  const res = await api.get(`${DEPARTMENT.ACTIVE}`);
  return res;
}

const deptService = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem
};

export default deptService;
